import React, { Component } from "react";

import AppBar from "@material-ui/core/AppBar";
import MenuIcon from "@material-ui/icons/Menu";
import GetAppIcon from "@material-ui/icons/GetApp";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getAllDownloadsRequest } from "../actions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AccountCircle from "@material-ui/icons/AccountCircle";

const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: 960,
    margin: "0 auto"
  },
  title: {
    flexGrow: 1
  },
  link: {
    textDecoration: "none",
    color: "white"
  },
  table: {
    minWidth: 960
  }
});

export const Logged = props => (
  <Menu
    {...props}
    iconButtonElement={
      <IconButton>
        <AccountCircle />
      </IconButton>
    }
    targetOrigin={{ horizontal: "right", vertical: "top" }}
    anchorOrigin={{ horizontal: "right", vertical: "top" }}
  >
    <MenuItem primaryText="Refresh" />
    <MenuItem primaryText="Sign out" />
  </Menu>
);

const CustomTableCell = withStyles(theme => ({
  head: { fontSize: 16, width: "20%" },
  body: { fontSize: 12 }
}))(TableCell);

const downloadCellStyle = {
  fontSize: 16,
  width: "5%"
};

class Downloads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      clickedRow: -1,
      downloads: []
    };
  }

  componentDidMount() {
    this.props.getAllDownloadsRequest();
  }

  handleRowSelection = (event, index) => {
    // const selectedRows =
    //   this.state.selected.indexOf(index) < 0
    //     ? [...this.state.selected, index]
    //     : _.remove(this.state.selected, function(num) {
    //         return num !== index;
    //       });
    const selectedRows = [index];
    console.log("Selected row " + selectedRows);
    this.setState({
      selected: selectedRows
    });
  };

  handleCellClick = (rowNumber, columnId) => {
    if (columnId === 4) {
      console.log("Clicked on row " + rowNumber + " and columnId " + columnId);
      this.setState({
        clickedRow: rowNumber
      });
    }
  };
  isSelected = index => {
    return this.state.selected.indexOf(index) !== -1;
  };

  // handleButtonClick = (evt) => {
  //     console.log("Caller selected " + evt + " on target " + evt.target);
  //     console.log("Selected row is " + this.state.clickedRow);
  // };

  render() {
    const classes = this.props.classes;
    console.log("During render props is: " + JSON.stringify(this.props));
    const tableData = this.props.downloads ? this.props.downloads : [];
    const errorMessage = this.props.errorMessage;
    const appButtonLabel = this.props.loggedIn ? "Logout" : "Login";
    console.log(tableData);
    return errorMessage ? (
      <Redirect to="/login" />
    ) : (
      <div className={classes.root}>
        <AppBar title="Home" position="static">
          <Toolbar>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
            >
              <a href="https://www.openempi.org" className={classes.link}>
                <MenuIcon />
              </a>
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              OpenEMPI Downloads
            </Typography>
            <Button color="inherit">
              <Link to="/login" className={classes.link}>
                {appButtonLabel}
              </Link>
            </Button>
          </Toolbar>
        </AppBar>

        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <CustomTableCell>Name</CustomTableCell>
              <CustomTableCell>Description</CustomTableCell>
              <CustomTableCell>Release Date</CustomTableCell>
              <CustomTableCell style={downloadCellStyle}>Size</CustomTableCell>
              <CustomTableCell style={downloadCellStyle}>
                Download
              </CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={index}
                hover={true}
                onClick={event => this.handleRowSelection(event, index)}
                selected={this.state.selected.indexOf(index) >= 0}
              >
                <CustomTableCell>{row.name}</CustomTableCell>
                <CustomTableCell>{row.description}</CustomTableCell>
                <CustomTableCell>{row.dateReleased}</CustomTableCell>
                <CustomTableCell>{row.size}</CustomTableCell>
                <CustomTableCell>
                  <IconButton
                    key={index}
                    tooltip="Download"
                    style={styles.small}
                  >
                    <a href={row.downloadLink} download={row.name}>
                      <GetAppIcon />
                    </a>
                  </IconButton>
                </CustomTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { downloads, status, errorMessage } = state.downloads;
  const { loggedIn } = state.authentication;
  console.log("In downloads state is " + JSON.stringify(state.authentication));
  if (downloads) {
    return { loggedIn, downloads };
  } else {
    return { loggedIn, errorMessage, status };
  }
}

export default connect(
  mapStateToProps,
  { getAllDownloadsRequest }
)(withStyles(styles)(Downloads));
